import { render, staticRenderFns } from "./SupplierReturnList.vue?vue&type=template&id=ca20bfae&"
import script from "./SupplierReturnList.vue?vue&type=script&lang=js&"
export * from "./SupplierReturnList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports